import {DateTime} from 'luxon';

export default class AnticipatedShipDate {

	constructor ({
		anticipatedShipDate = '',
		holidays = window.mivaJS.holidays,
		leadTime = 1,
		timeZone = 'America/Chicago'
	}) {
		this.timeZone = timeZone;
		this.anticipatedShipDate = anticipatedShipDate;
		this.leadTime = leadTime;
		this.holidays = holidays ? holidays?.split(',')?.map(holiday => DateTime.fromFormat(holiday?.trim(), 'MM/d/y', {
			zone: this.timeZone
		}).startOf('day')) : [];
	}

	get () {
		if (this.anticipatedShipDate) {
			return DateTime.fromFormat(this.anticipatedShipDate.trim(), 'M/d/y').setZone(this.timeZone);
		}

		/*
		 * Determine the current hour.
		 * If it's past 1pm CST, then add an extra day.
		 */
		const currentHour = parseInt(DateTime.local().setZone(this.timeZone).toFormat('H'), 10);
		let leadTime = this.leadTime;

		/*
		 * Set the current shipsBy with the days we're adding from the above logic
		 */
		let shipsBy = DateTime.now().setZone(this.timeZone).startOf('day');
		if (currentHour >= 13) {
			shipsBy = shipsBy.plus({days: 1});
		}

		/*
		 * Add 1 day per each loop while `leadTime` is greater than 0
		 * If we land on a Saturday/ Sunday, skip
		 * If we land on a holiday, skip
		 */
		while (leadTime > 0) {
			shipsBy = shipsBy.plus({days: 1});
			const weekdayNumber = shipsBy.toFormat('E');

			if (weekdayNumber > 5) {
				continue;
			}

			if (this.isHoliday(shipsBy)) {
				continue;
			}

			leadTime--;
		}

		return shipsBy;
	}

	isHoliday (shipsBy) {
		return this.holidays.find((holiday) => holiday.toFormat('MM/dd/y') === shipsBy.toFormat('MM/dd/y'));
	}

}
